import main from './main';

const theme = {
	main,
};

export default theme;
